// extracted by mini-css-extract-plugin
export default {"tabMain":"truckPage_ui_tabMain__GGeCP","wrapper":"truckPage_ui_wrapper__rq7Dr","item":"truckPage_ui_item__xPgr7","cardImg":"truckPage_ui_cardImg__c9hfW"};